import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'

const CareerIntro = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_ 1 padding center-cont">
				<div className="slider">
					<ul>
						<li>
							<i className="icon icon_other_search" />
							<h3 className="intro-tit mt_20">내 커리어를 한 번에 조회하세요!</h3>
							<p className="intro-sub-tit mt_10">
								현재 재직상태와 소득정보부터<br />
								재직중인 회사의 정보까지 확인할 수 있어요!
							</p>
						</li>
						{/* <li>
							<i className="icon icon_bag_object" />
							<h3 className="intro-tit mt_20">지금까지 내 경력을 한 눈에 확인하세요!</h3>
							<p className="intro-sub-tit mt_10">
								총 경력부터 최근 3년간 소득이<br />
								얼마나 올랐는지 알려드려요!
							</p>
						</li>
						<li>
							<i className="icon icon_info_object" />
							<h3 className="intro-tit mt_20">궁금했던 회사의 정보를 알 수 있어요!</h3>
							<p className="intro-sub-tit mt_10">
								사업자번호만 입력하면<br />
								회사 기본정보부터 재무정보까지!
							</p>
						</li> */}
					</ul>
					<ul className="slider-dots dots-gray" style={{ marginTop: "14rem" }}>
						<li className="active" />
						<li />
						<li />
					</ul>
				</div>
			</div>
			<div className="padding flex-shrink_0">
				<Button className="btn btn--big">조회하기</Button>
			</div>
		</div>
	)
}

export default CareerIntro
